import axios from '@/libs/api.request';

export const updateProductPrice = data => {
    return axios.request({
        url: 'api/productManagement/productPrice/updateProductPrice',
        data: data,
        method: 'post'
    });
};

export const updateProductAgent = data => {
    return axios.request({
        url: 'api/productManagement/productPrice/updateProductAgent',
        data: data,
        method: 'post'
    });
};
